import { render, staticRenderFns } from "./TaxInvoiceManageDetail.vue?vue&type=template&id=1f45c919&"
import script from "./TaxInvoiceManageDetail.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceManageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports